import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import {
    ModalWrapper,
    ButtonWrapper,
    TitleText,
    WarningText,
    TitleWrapper,
    StyledBackdrop,
} from "./Styled";
import CustomButton from "../TitleRow/CustomButton";

interface ReasonTextModalProps {
    open: boolean;
    handleClose: () => void;
    title?: string;
    contentText?: string[];
}

const ReasonTextModal = ({
    open,
    handleClose,
    title,
    contentText = [],  // Default to empty array if no contentText is passed
}: ReasonTextModalProps) => {
    const [text, setText] = useState("");

    const handleCloseWithAnimation = () => {
        setTimeout(handleClose, 100);
    };

    // Calculate padding-top based on the number of items in the contentText array
    const getPaddingTop = (index: number) => {
        return index === 0 ? "24px" : "8px"; // 24px for the first item, 8px for others
    };

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={open}>
                <TitleWrapper>
                    <TitleText>{title}</TitleText>
                    {/* Render each item in contentText dynamically with adjusted padding */}
                    {contentText.map((text, index) => (
                        <WarningText key={index} paddingTop={getPaddingTop(index)}>
                            {text}
                        </WarningText>
                    ))}
                </TitleWrapper>
                <ButtonWrapper>
                    <CustomButton
                        title="Đóng"
                        onClick={handleCloseWithAnimation}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            width: "40%",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    />
                </ButtonWrapper>
            </ModalWrapper>
        </Modal>
    );
};

export default ReasonTextModal;
